'use strict';

window._theme = window._theme || {};
window.addEventListener('DOMContentLoaded', function (evt) {
  document.querySelectorAll('.sample-prod-atc').forEach((el) => {
    el.addEventListener('click', (e) => {
      const sampleProdId = parseInt(
        e.target.closest('.sample-prod-atc').getAttribute('data-prod-id')
      );
      _theme.Helpers.addProductToCart(sampleProdId, 1, null, function (resp) {
        _theme.MiniCart.lineItemChangeCallBack(resp, function () {
          _theme.toggleLoading();
          _theme.toggleSideCart(1, null, true);
        });
      });
    });
  });
  const transcriptModalBtn = document.querySelector('.transcript-modal-btn');
  const transcriptModalBox = document.querySelector('.transcript-modal');
  const transcriptCloseModalBox = document.querySelector('.close-transcript-modal');
  transcriptModalBtn.addEventListener('click', () => {
    transcriptModalBox.classList.add('active');
    if (_theme.isMobile) {
      $('*')
        .not($('.transcript-modal').find('*'))
        .not('.transcript-modal')
        .not($('.transcript-modal').parents())
        .attr('aria-hidden', 'true');
    }
    _theme.focusTrap($('.transcript-modal'), function () {
      $('.close-transcript-modal').focus();
    });
    document.querySelector('body').classList.add('transcript-modal-open');
    _theme.toggleOverlay(1);
  });
  transcriptCloseModalBox.addEventListener('click', () => {
    transcriptModalBox.classList.remove('active');
    if (_theme.isMobile) {
      $('*')
        .not($('.transcript-modal').find('*'))
        .not('.transcript-modal')
        .not($('.transcript-modal').parents())
        .removeAttr('aria-hidden', 'true');
    }
    _theme.toggleOverlay(0);
    document.querySelector('body').classList.remove('transcript-modal-open');
  });
  _theme.initSlickSlider($('.sample-img'), {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [{ breakpoint: 1024, settings: { arrows: false } }],
  });
  function toggleLabels(buttonSelector, targetSelector, displayStyle) {
    document.querySelectorAll(buttonSelector).forEach((button) => {
      button.addEventListener('mouseenter', () => {
        document.querySelectorAll(targetSelector).forEach((label) => {
          label.style.display = displayStyle;
        });
      });

      button.addEventListener('mouseleave', () => {
        document.querySelectorAll(targetSelector).forEach((label) => {
          label.style.display = '';
        });
      });
    });
  }

  toggleLabels('.slick-prev', '.slick-next .screen-reader-only', 'none');
  toggleLabels('.slick-next', '.slick-prev .screen-reader-only', 'none');

  const videoBtns = document.querySelectorAll('.play-pause-button');
  const video = document.querySelector(
    window.innerWidth > 1024 ? 'video.visible-desktop' : 'video.visible-mobile'
  );

  if (video) {
    const togglePlayPause = () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    };

    videoBtns.forEach((btn) => {
      btn.addEventListener('click', togglePlayPause);

      video.addEventListener('play', () => btn.classList.add('active'));
      video.addEventListener('pause', () => btn.classList.remove('active'));
    });
  }
});
